export default __webpack_public_path__ + "812d943d3cc82d39a26b7a7c2fe9ce9d.png";